module.exports = __webpack_public_path__ + "assets/img/1020.e736a896.svg";